import { render, staticRenderFns } from "./VideoViewModal.vue?vue&type=template&id=253f42f0&scoped=true&"
import script from "./VideoViewModal.vue?vue&type=script&lang=js&"
export * from "./VideoViewModal.vue?vue&type=script&lang=js&"
import style0 from "./VideoViewModal.vue?vue&type=style&index=0&id=253f42f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253f42f0",
  null
  
)

export default component.exports